<p>behavior-code-entry-edit-reaction works!</p>
